<template>
  <div class="subscribe-vacancies-banner">
    <div class="banner-wrapper">
      <div class="content">
        <div class="title">Хотите получать новые вакансии на почту?</div>
        <div v-if="description" v-sane-html="description" class="description" />
        <BaseButton class="button" name="Да, хочу" @click="showSubscribeForm" />
      </div>
      <div class="image">
        <img src="~/assets/images/banners/vacancies/subscribe.png" alt="Image" />
      </div>
    </div>
    <client-only>
      <SubscribeFormModal
        v-if="showSubscribeModal"
        v-model="showSubscribeModal"
        :subscribe-params="subscribeParams"
      />
    </client-only>
  </div>
</template>

<script lang="ts" setup>
  import { BaseButton } from '~/components/base-ui/buttons'
  import { SubscribeFormModal } from '~/components/modals'
  import type { SubscribeInputParams } from '~/types/subscriptions'

  defineProps<{
    description?: string
    subscribeParams: SubscribeInputParams
  }>()

  const { reachGoal } = useYandexMetric()
  const showSubscribeModal = ref(false)

  const showSubscribeForm = () => {
    showSubscribeModal.value = true
    reachGoal('click_banner_email-newsletter')
  }
</script>

<style scoped lang="scss">
  .subscribe-vacancies-banner {
    > .banner-wrapper {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      border-radius: 20px;
      background: linear-gradient(131deg, #cff2fd -28.36%, #deedff 113.83%);
      overflow: hidden;

      > .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 32px;
        width: 100%;

        @include vp-767 {
          padding: 24px 16px;
        }

        > .title {
          font-size: 24px;
          font-weight: 500;
          line-height: 32px;
        }

        > .description {
          display: flex;
          align-items: center;
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
        }

        > .button {
          min-width: 175px;
          max-width: fit-content;
          font-size: 14px;
          line-height: 22px;

          @include vp-767 {
            width: 100%;
            max-width: unset;
          }
        }
      }

      > .image {
        display: flex;
        justify-content: center;
        min-width: 370px;
        max-width: 370px;

        @include vp-1279 {
          min-width: 170px;
          max-width: 170px;
        }

        @include vp-767 {
          display: none;
        }

        > img {
          align-self: end;
          max-height: 210px;
        }
      }
    }
  }
</style>
